import React from 'react';
import { useTranslation } from 'react-i18next';
import ContentWrapperInteractionStatus from '../ContentWrapperInteractionStatus/ContentWrapperInteractionStatus';
import ContentWrapperLoadingSpinner from '../ContentWrapperLoadingSpinner/ContentWrapperLoadingSpinner';
import { Namespace } from '../../../../../translation/namespace';
import {
  AddContentBlockForm,
  AddContentBlockFormProps,
} from '../../../../organisms/BlockInteractions/forms/AddContentBlockForm/AddContentBlockForm';
import { ActionState, ErrorState } from '../../useContentWrapper';
import { GlobalDocumentIds } from '../../../../../types/GlobalDocumentIds';
import { ContentWrapperAction as Action } from '../../ContentWrapper.types';

type AddContentBlock = AddContentBlockFormProps & {
  error: ErrorState | null;
  action: ActionState | null;
};

/** Responsible for adding blocks in the ContentWrapper  */
export function AddContentBlock({
  uuid,
  action,
  setAction,
  addBlock,
  error,
  setError,
  form,
  position,
}: AddContentBlock) {
  const { t } = useTranslation(Namespace.ContentWrapper);

  const hasError = error?.uuid === uuid && error?.type === Action.addBlock;
  const isLoading = action?.uuid === uuid && action?.type === Action.addBlock;

  const errorMessage = hasError ? t('errors.addBlock') : null;
  const loadingMessage = isLoading ? t('actions.addBlock.loadingMessage') : null;

  return (
    <>
      {(hasError || isLoading) && !uuid && (
        <div className="content-wrapper__container">
          {errorMessage && <ContentWrapperInteractionStatus message={errorMessage} />}
          {loadingMessage && <ContentWrapperLoadingSpinner loadingMessage={loadingMessage} />}
        </div>
      )}
      <div
        className="add-content-block-form"
        id={GlobalDocumentIds.addContentBlock} // important to be focused via ContentWrapper
      >
        <h2 className="add-content-block-form__headline">{t(`${Namespace.AddContentBlockForm}:headline`)}</h2>
        <div className="add-content-block-form__buttons">
          <AddContentBlockForm
            uuid={uuid}
            form={form}
            addBlock={addBlock}
            setAction={setAction}
            setError={setError}
            position={position}
          />
        </div>
      </div>
    </>
  );
}
